const encodedURIComponentQueryStringConverter = (url = '/', params = {}) => {
  let querystring = ''
  for (const key in params) {
    if (params[key]) {
      querystring += `${(querystring.length ? '&' : '') +
        key}=${encodeURIComponent(params[key])}`
    }
  }
  return url + (querystring ? `?${querystring}` : '')
}

export default encodedURIComponentQueryStringConverter
